import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Слияние Tailwind-классов с разрешением конфликтов.
 *
 * Конкатенация строк вместо cn() даёт классы вида "px-2 px-4" — побеждает не последний,
 * а тот, что стоит позже в собранном CSS, то есть результат зависит от порядка сборки,
 * а не от кода. twMerge выкидывает перекрытые утилиты, clsx раскрывает условия.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
